import { createTracker } from '@mathflat/data-tracking'

import {
  buildStudentTrackerOptions,
  GLOBAL_PROPERTIES_VERSION,
  USER_PROPERTIES_VERSION,
} from './mixpanelConfig'
import { eventCatalog } from './schema/event.schema'
import type { GlobalEventPropertiesSchema } from './schema/globalEventProperties.schema'
import type { UserPropertiesSchema } from './schema/userProperties.schema'

const tracker = createTracker(eventCatalog, buildStudentTrackerOptions())

export const mixpanelClient = {
  track: tracker.track,
  identify: tracker.identify,
  setGlobalEventProperty: (props: Partial<GlobalEventPropertiesSchema>) =>
    tracker.setGlobalProps({ ...props, globalPropertiesVersion: GLOBAL_PROPERTIES_VERSION }),
  setUserProperty: (props: Partial<UserPropertiesSchema>) =>
    tracker.setUserProps({ ...props, userPropertiesVersion: USER_PROPERTIES_VERSION }),
  // opt-in 때 SDK 가 기본으로 보내는 $opt_in 이벤트를 막는다
  optInTracking: (options?: Parameters<typeof tracker.optIn>[0]) =>
    tracker.optIn({ track: () => undefined, ...options }),
  optOutTracking: tracker.optOut,
}
